import {
  PRODUCT_CATEGORIES_DIALOG_MESSAGES,
  ProductCategoriesDialogMessages,
} from "./product-categories-dialog.messages";
import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";

export type ProductCategoriesTableMessages = ProductCategoriesDialogMessages &
  PopoverMessages & {
    // Titles messages
    categoryTableTitle: string;

    // Column Labels
    codeColumn: string;
    optionsColumn: string;

    // Tooltip Messages
    disableDeleteTooltipHasChildren: string;
    disableDeleteTooltipNoPermission: string;
  };

export const PRODUCT_CATEGORIES_TABLE_MESSAGES: ProductCategoriesTableMessages = {
  // Titles messages
  categoryTableTitle: "Árvore de Categorias",

  // Column Labels
  codeColumn: "Código",
  optionsColumn: "Opções",

  // Tooltip Messages
  disableDeleteTooltipHasChildren: "Não é possível remover categorias que possuem subcategorias.",
  disableDeleteTooltipNoPermission: "Você não tem permissão para remover esta categoria.",

  ...PRODUCT_CATEGORIES_DIALOG_MESSAGES,
  ...POPOVER_MESSAGES,
};
